<template>
  <div id="app">
<div id="IntroVideoWrap" v-show="$route.name=='home'">
  <video width="100%" height="auto" autoplay="autoplay" muted >
    <source src="static/intro.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
  </video>
</div>

    <div id="myNav" class="overlay">
        <div id="MenuIconClose"><span class="hamburger__icon"></span></div>
        <div class="bg_box"></div>
        <!-- Overlay content -->
        <div class="overlay-content">

          <div class="row">
            <div class="col-md-12">
              <router-link to="/" data-aos="fade-up" data-aos-offset="0" data-aos-delay="0">Home</router-link>
              <router-link to="/about-us" data-aos="fade-up" data-aos-offset="0" data-aos-delay="50">About Us </router-link>
              <router-link to="/services" data-aos="fade-up" data-aos-offset="0" data-aos-delay="100">Services </router-link>
              <router-link to="/finishes"  data-aos="fade-up" data-aos-offset="0" data-aos-delay="150">Finishes </router-link>
              <router-link to="/our-clients"  data-aos="fade-up" data-aos-offset="0" data-aos-delay="150">Clients </router-link>
              <router-link to="/portfolio" data-aos="fade-up" data-aos-offset="0" data-aos-delay="200">Portfolio </router-link>
              <router-link to="/catalog" data-aos="fade-up" data-aos-offset="0" data-aos-delay="200">Catalog </router-link>
              <router-link to="/cab-builder" data-aos="fade-up" data-aos-offset="0" data-aos-delay="250">CAB Builder </router-link>
              <router-link to="/contact-us" data-aos="fade-up" data-aos-offset="0" data-aos-delay="250">Contact Us </router-link>
            </div>
          </div>

        </div>

          <div id="MenuSocial">
            <div class="row">
              <div class="col-md-12">
                <a href="https://www.facebook.com/USC-Elevator-Interiors-456787351159246/" target="_blank"><i class="fa fa-facebook-official fa-2x" aria-hidden="true"></i> FACEBOOK</a>
                <a href="http://twitter.com/USCElevators"  target="_blank"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i> TWITTER</a>
                <a href="https://www.instagram.com/uscelevatorinteriors"><i class="fa fa-instagram fa-2x" aria-hidden="true"></i> INSTAGRM</a>
                <a href="https://www.linkedin.com/company/usc-elevator-interiors" target="_blank"><i class="fa fa-linkedin-square fa-2x" aria-hidden="true"></i> LINKEDIN</a>
                <a href=""><i class="fa fa-dribbble fa-2x" aria-hidden="true"></i> DRIBBLE</a>
              </div>
            </div>
          </div>

    </div>
    
    <rwv-header></rwv-header>
    <div id="SiteWrapper">
        <router-view/>
        <rwv-footer></rwv-footer>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery'
//import 'paroller.js';


import '@/assets/js/jquery-inertiaScroll'


import RwvHeader from '@/components/Header'
import RwvFooter from '@/components/Footer'
export default {
  name: 'App',
  components: {
    RwvHeader,
    RwvFooter
  },
  mounted() {
        $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });

        $('#IntroVideoWrap video').bind('ended', function(){
           $(this).parent().fadeOut()
        });


        var bodyH = false;
        $(document).on('scroll', function() {
              var scroll = $(window).scrollTop();

              
              if(bodyH != true){
                var body = $("body");
                $("body").height($("#SiteWrapper").height());
                bodyH = true;
              }
        });


        //Catch resize
        $(window).resize(function() {
        if(this.resizeTO) clearTimeout(this.resizeTO);
         this.resizeTO = setTimeout(function() {
           $(this).trigger('resizeEnd');
         }, 100);
        });
        /******/  

        //Act after resize
        $(window).bind('resizeEnd', function() {
              //$('.match').matchHeight();
              $("body").height($("#SiteWrapper").height());
        }); 
        setTimeout(function() {
          $("body").height($("#SiteWrapper").height());
        }, 1500);

  },
  updated(){
        //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
        setTimeout(function() {
          $(this).trigger('resize');
        }, 100);

        
        setTimeout(function() {
          $("body").height($("#SiteWrapper").height());
          //alert('xxxxxxxxxxxxxxx');
        }, 2000);

        $('#IntroVideoWrap').hide();
  }
}
</script>

<style lang="scss" >
 @import './assets/scss/style.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue